"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "productReducer", {
  enumerable: true,
  get: function get() {
    return _reducer.default;
  }
});
Object.defineProperty(exports, "productState", {
  enumerable: true,
  get: function get() {
    return _state.default;
  }
});
Object.defineProperty(exports, "productMutator", {
  enumerable: true,
  get: function get() {
    return _mutator.transformProduct;
  }
});
exports.productActions = void 0;

var productActions = _interopRequireWildcard(require("./actions"));

exports.productActions = productActions;

var _reducer = _interopRequireDefault(require("./reducer"));

var _state = _interopRequireDefault(require("./state"));

var _mutator = require("./mutator");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}